export default Object.freeze({
  PLANNED: 'PLN',
  ENROLLED: 'ENR',
  PASS: 'PASS',
  FAIL: 'FAIL',
  WITHDRAWNEARLY: 'WDE',
  WITHDRAWN: 'WD'
})
